import * as React from 'react'
// context
import { RiskFormContext } from 'containers/Risks/RiskForm/layers/BL'

export const useCurrentForm = () => {
  return React.useContext(RiskFormContext)
}
